import * as React from "react";

// vedi altri css-loaders https://dev.to/afif/i-made-100-css-loaders-for-your-next-project-4eje#the-classic
const Bootstrap: React.FC = () => {
    return (
        <div className="bg-gray-600 flex items-center justify-center h-screen">
            <div className="flex space-x-3 animate-pulse">
                <div className="w-8 h-8 bg-blue-400 rounded-full"></div>
                <div className="w-8 h-8 bg-blue-400 rounded-full"></div>
                <div className="w-8 h-8 bg-blue-400 rounded-full"></div>
            </div>
        </div>
        /*
            <div className={styles.divBody}>
                <div className={styles.dots7}></div>
            </div>
        */
    )
}
export default Bootstrap;